import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Link,
  Checkbox,
  Box
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { translator } from "../../utils/i18n";
import { Trans } from "@lingui/macro";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword, login } from "../../utils/session";
import useForm from "react-hook-form";
import ErrorIcon from "@material-ui/icons/Error";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4),
    maxWidth: 400,
    margin: "auto"
  }
}));

const LoginForm = () => {
  const classes = useStyles();
  const { handleSubmit, register, errors, getValues } = useForm();

  const dispatch = useDispatch();
  const message = useSelector(state => state.messageWithCode);
  const messageConnexion = useSelector(state => state.message);
  const [messageRequiredEmail, setMessageRequiredEmail] = useState("");
  const connexionPatient = values => dispatch(login(values));
  const forgetPassword = email => dispatch(forgotPassword({ email: email }));

  const forgetPasswordFunc = email => {
    setMessageRequiredEmail("");
    if (!email) {
      setMessageRequiredEmail(translator()._("CP_RESET_PW_TEXT"));
    } else {
      forgetPassword(email);
    }
  };

  const onSubmit = values => {
    setMessageRequiredEmail("");
    connexionPatient(values);
  };

  return (
    <Box className={classes.paper}>
      <Typography
        variant="h5"
        component="h1"
        style={{
          textAlign: "center",
          marginBottom: "12px",
          fontWeight: "bold"
        }}
      >
        {`J'ai déjà un compte`}
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        {messageConnexion && (
          <div className="mb-10 custom-message custom-alert align-items-center">
            <ErrorIcon />
            {messageConnexion}
          </div>
        )}
        {message && !messageRequiredEmail && message.text && (
          <div
            className={
              message.code === 1
                ? "custom-message custom-success align-items-center mb-10"
                : "custom-message custom-alert align-items-center mb-10"
            }
          >
            {message.code === 1 ? <CheckCircleIcon /> : <ErrorIcon />}
            <div dangerouslySetInnerHTML={{ __html: message.text }} />
          </div>
        )}
        {messageRequiredEmail && (
          <div className="mb-10 custom-message custom-alert align-items-center">
            <ErrorIcon />
            {messageRequiredEmail}
          </div>
        )}
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          id="email"
          label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
          autoComplete="email"
          autoFocus
          style={{ backgroundColor: "white" }}
          name="email"
          placeholder={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
          ref={register({
            required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`,
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
              message: `${translator()._("W_ADRESSE_E_MAIL_NON_VALIDE")}`
            }
          })}
        />
        <span className="error">{errors.email && errors.email.message}</span>
        <TextField
          variant="outlined"
          margin="normal"
          fullWidth
          label={translator()._("CP_PASSWORD")}
          id="password"
          autoComplete="current-password"
          placeholder={translator()._("CP_PASSWORD")}
          name="password"
          type="password"
          ref={register({
            required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`
          })}
          style={{ backgroundColor: "white" }}
        />
        <span className="error">
          {errors.password && errors.password.message}
        </span>

        <Typography component="h1">
          <Checkbox style={{ color: "#009EFF" }} />
          {`Mémoriser mon identifiant`}
        </Typography>

        <Button
          type="submit"
          fullWidth
          variant="outlined"
          style={{
            borderRadius: "50px",
            height: "40px",
            backgroundColor: "#C8C8C8",
            border: "#C8C8C8",
            color: "white",
            textTransform: "none",
            fontSize: "18px",
            marginTop: "8px"
          }}
        >
          {translator()._("W_SE_CONNECTER")}
        </Button>
        <Typography style={{ textAlign: "center", marginTop: "10px" }}>
          <Link
            onClick={() => forgetPasswordFunc(getValues().email)}
            underline="always"
          >
            <Trans id="W_STEP4_ACCES_MEMBRE_MOT_DE_PASSE_OUBLIE" />
          </Link>
        </Typography>
      </form>
    </Box>
  );
};

export default LoginForm;
